import { gql } from "@apollo/client";

export const MY_HR_FORGOT_PASSWORD = gql`
  query forgotPassword($email: String!, $locale: String!) {
    forgotPassword(email: $email, locale: $locale) {
      status
      statusMessage
    }
  }
`;
